
(() => {
  function loadVideo(tile) {
    if (!tile || tile.dataset.loaded === "true") return;
    const src = tile.getAttribute("data-mh-video-load");
    const label = tile.querySelector("b")?.textContent || "Factory proof video";
    const video = document.createElement("video");
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = "metadata";
    video.src = src;
    video.setAttribute("aria-label", label);
    tile.dataset.loaded = "true";
    tile.replaceChildren(video, Object.assign(document.createElement("span"), { textContent: label }));
  }
  document.addEventListener("click", (event) => loadVideo(event.target.closest("[data-mh-video-load]")));
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;
    const tile = event.target.closest("[data-mh-video-load]");
    if (!tile) return;
    event.preventDefault();
    loadVideo(tile);
  });

  function cleanB2BStorefront() {
    const replacements = [
      ["Emilychen@wancheng-electricalsteel.com", "info@wancheng-electricalsteel.com"],
      ["emilychen@wancheng-electricalsteel.com", "info@wancheng-electricalsteel.com"],
      ["Lunachen@wancheng-electricalsteel.com", "info@wancheng-electricalsteel.com"],
      ["luna@wancheng-electricalsteel.com", "info@wancheng-electricalsteel.com"],
      ["Sophiazhuang@wancheng-electricalsteel.com", "info@wancheng-electricalsteel.com"],
      ["sophiazhuang@wancheng-electricalsteel.com", "info@wancheng-electricalsteel.com"],
      ["Peggy@wancheng-electricalsteel.com", "info@wancheng-electricalsteel.com"],
      ["+86 159 1535 2658", "+86 137 1285 3768"],
      ["86-159 1535 2658", "+86 137 1285 3768"],
      ["+86 159 1533 5158", "+86 137 1285 3768"],
      ["86-159 1533 5158", "+86 137 1285 3768"],
      ["+86 159 1538 2358", "+86 137 1285 3768"],
      ["86-159 1538 2358", "+86 137 1285 3768"],
      ["+86 137 1396 6803", "+86 137 1285 3768"],
      ["not online checkout", "not online shopping"],
      ["No price, cart or checkout is shown", "Public prices are not shown"],
      ["consumer checkout", "retail purchasing"],
      ["cart or checkout", "retail purchasing"],
      ["cart and checkout", "retail purchasing"],
      ["without cart or checkout steps", "without retail purchasing steps"]
    ];
    document
      .querySelectorAll('a[href*="/cart"], a[href*="/account"], a[href*="/checkout"], form[action*="/cart"], button[name="add"], button[id*="ProductSubmitButton"], product-form, quantity-selector, cart-icon, cart-drawer, cart-drawer-component, shopify-accelerated-checkout, shopify-accelerated-checkout-cart')
      .forEach((node) => node.remove());
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach((node) => {
      let value = node.nodeValue;
      replacements.forEach(([from, to]) => {
        value = value.split(from).join(to);
      });
      node.nodeValue = value;
    });
    document.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
      if (!link.href.toLowerCase().includes("info@wancheng-electricalsteel.com")) link.href = "mailto:info@wancheng-electricalsteel.com";
    });
    document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"]').forEach((link) => {
      link.href = "https://wa.me/8613712853768";
    });
  }

  cleanB2BStorefront();
  document.addEventListener("DOMContentLoaded", cleanB2BStorefront);
  window.addEventListener("load", cleanB2BStorefront);
  window.setTimeout(cleanB2BStorefront, 1200);
})();
